<template>
    <div>
        <div class="breadcrumb-section jarallax pixels-bg" data-jarallax data-speed="0.6">
            <div class="container text-center">
                <h1>{{ (product != null) ? product.name.toUpperCase() : '' }}</h1>
                <ul>
                    <li><router-link to="/">Accueil</router-link></li>
                    <li><router-link to="/nos-produits">Nos produits</router-link></li>
                    <li><a href="javascript:void(0);">{{ (product != null) ? product.name : '' }}</a></li>
                </ul>
            </div>
        </div>
        <div class="section-block">
            <div class="container">
                <div class="row mt-20" v-if="product != null">
                    <div class="col-md-6">
                        <p v-html="product.description"></p>
                        <br />
                        <span style="font-size: 18px;" v-if="product.price != null">
                            {{ 'Prix : ' + product.price + ' FCFA ' + (product.price_surfix != null) ? product.price_surfix : '' }}
                        </span>
                        <br /><br />
                        <router-link to="/contactez-nous" class="button-sm button-primary">Nous contacter</router-link>
                    </div>
                    <div class="col-md-6">
                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li
                                    data-target="#carouselExampleIndicators"
                                    v-for="(image, index) in product.images" :key="index"
                                    :data-slide-to="index" :class="(index == 0 ? 'active' : '')"
                                >
                                </li>
                            </ol>
                            <div class="carousel-inner">
                                <div :class="(index == 0 ? 'carousel-item active' : 'carousel-item')" v-for="(image, index) in product.images" :key="index">
                                    <img class="d-block w-100" :src="url + '/' + image.path" alt="">
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row mt-40" v-else>
                    <div class="col-md-12">
                        <div class="alert alert-info">
                            Chargement en cours ...
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-block-bg" v-if="otherProducts.length > 0">
            <div class="background-shape bs-right"></div>
            <div class="container">
                <div class="section-heading text-center">
                    <h4 class="semi-bold">Ses produits pourront peut-être vous intéresser</h4>
                    <div class="section-heading-line line-thin"></div>
                </div>
                <div class="row mt-40">
                    <div class="col-md-4 col-sm-4 col-12" v-for="(otherProduct, key) in otherProducts" :key="key">
                        <div class="blog-grid">
                            <img :src="url + '/' + otherProduct.images[0].path" alt="" style="width:650;heigth:500;">
                            <div class="blog-team-box">
                                <h6>{{ otherProduct.service.name }}</h6>
                            </div>
                            <h4><a :href="'/produit/' + otherProduct.slug">{{ otherProduct.name }}</a></h4>
                            <p v-short-description="{htmlText: otherProduct.description, count: 130}"></p>
                            <a :href="'/produit/' + otherProduct.slug" class="button-simple-primary mt-20">
                                Détails<i class="fas fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '../../config/urls'
export default {
  name: 'ProductDetails',
  data () {
    return {
      product: null,
      otherProducts: [],
      url: BASE_URL
    }
  },
  mounted () {
    this.getProduct().then((product) => this.getProductsByService(product.id, product.service.id))
  },
  methods: {
    getProduct () {
      return new Promise((resolve, reject) => {
        let url = BASE_URL + API_PREFIX + API_VERSION + '/products-by-slug/' + this.$route.params.productSlug
        this.$http.get(url)
          .then((response) => {
            this.product = response.data
            resolve(this.product)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getProductsByService (currentProductId, serviceId) {
      return new Promise((resolve, reject) => {
        let url = BASE_URL + API_PREFIX + API_VERSION + '/products-by-service/' + serviceId
        this.$http.get(url)
          .then((response) => {
            response.data.filter((item) => {
              if (item.id !== currentProductId) { this.otherProducts.push(item) }
            })
            resolve(this.otherProducts)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ProductDetails.vue